/* Global imports. */
import React from "react";
import { ImageElement } from "@kontent-ai/gatsby-components";
import { kontent } from "@src/constants";
import { Link } from "gatsby";

interface Props {
  kontentImage: any;
  url: string;
  description?: string;
  caption: string;
  alignment: "left" | "right" | "centered" | "full_width";
  ratio: "portrait" | "landscape";
  maxWidth?: number
  linkUrl?: string;
}

const Image = ({ url, description = "", caption, alignment, ratio, kontentImage, maxWidth, linkUrl }: Props) => {
  const alignmentClass = () => {
    switch (alignment) {
      case "left":
        return "max-w-full";
      case "right":
        return "max-w-full";
      case "centered":
        return "max-w-full mx-auto";
      case "full_width":
        return "max-w-full";
      default:
        return "";
    }
  };

  const figureClass = () => {
    switch (alignment) {
      case "left":
        return "inline-block float-left pb-4 max-w-[232px] pt-[5px] pr-8";
      case "right":
        return "inline-block float-right pb-4";
      case "centered":
        return ` text-center mx-auto my-6 ${ratio === "portrait" ? "max-w-[232px]" : "max-w-[600px]"}`;
      case "full_width":
        return `max-w-full text-center mx-auto my-6 image-full-width ${ratio === "portrait" ? "max-w-[300px] mx-auto" : ""}`;
      default:
        return "";
    }
  }

  return (
    <figure className={figureClass()}>
    {linkUrl && linkUrl !== "" ? 
        <Link to={linkUrl} className="no-underline">
            {kontentImage && kontentImage.width && kontentImage.height ? 
                <ImageElement
                    layout="constrained"
                    width={maxWidth}
                    image={kontentImage}
                    backgroundColor="#efefef"
                    alt={description}
                    className={alignmentClass()}
                /> 
                :
                <img src={url} alt={description} className={alignmentClass()} loading="lazy" />
            }
        </Link>
        :
        kontentImage && kontentImage.width && kontentImage.height ? 
            <ImageElement
                layout="constrained"
                width={maxWidth}
                image={kontentImage}
                backgroundColor="#efefef"
                alt={description}
                className={alignmentClass()}
            /> 
            :
            <img src={url} alt={description} className={alignmentClass()} loading="lazy" />
    }
      {caption && <figcaption className="mt-2 text-[#999] text-sm">{caption}</figcaption>}
    </figure>
  );
};

export default Image;
